export type ReceiptSource = "portal" | "deal" | "svr" | "ro";

/** Uses the existing public invoice bearer credential, never a numeric ID. */
export function paymentReceiptPdfPath(
  source: ReceiptSource,
  token: string
): string {
  return `/api/payment-receipts/${source}/${encodeURIComponent(token)}/receipt.pdf`;
}
